import lodash from "lodash";
import { Decoration_Type } from "./../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { parseLink } from "../../nodeUtils.js";
import { FROM_RICOS_DECORATION_TYPE, TO_RICOS_DECORATION_DATA_FIELD } from "../consts.js";
const convertDecorationToDraftData = (decoration) => {
  const { type } = decoration;
  const dataFieldName = TO_RICOS_DECORATION_DATA_FIELD[FROM_RICOS_DECORATION_TYPE[type]];
  return convertDecorationDataToDraft(
    type,
    decoration[dataFieldName]
  );
};
const convertDecorationDataToDraft = (decorationType, data) => {
  const converters = {
    [Decoration_Type.MENTION]: convertMentionData,
    [Decoration_Type.LINK]: convertLinkData
  };
  if (decorationType in converters) {
    const convert = converters[decorationType];
    const newData = lodash.cloneDeep(data);
    convert(newData);
    return newData;
  }
  return data;
};
const convertMentionData = (data) => {
  data.mention = { slug: data.slug, name: data.name, id: data.id };
  delete data.name;
  delete data.slug;
  delete data.id;
};
const convertLinkData = (data) => {
  if (data.link) {
    const { url, target, anchor, rel, customData } = parseLink(data.link);
    data.url = url;
    if (target) {
      data.target = target;
    }
    if (rel) {
      data.rel = rel;
    }
    if (anchor) {
      data.anchor = anchor;
    }
    if (customData) {
      const customDataObj = parseLinkCustomData(customData);
      lodash.merge(data, customDataObj);
    }
    delete data.link;
  }
};
const parseLinkCustomData = (customData) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error("failed to parse customData", customData);
    return { customData };
  }
};
export {
  convertDecorationDataToDraft,
  convertDecorationToDraftData
};
//# sourceMappingURL=convertDraftPluginData.js.map
